import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PageContentModel } from 'src/app/models/page-content.model';

declare function openNewTab(url: string): void

@Component({
    selector: 'app-link-button',
    templateUrl: './link-button.component.html',
    styleUrls: ['./link-button.component.scss'],
    standalone: false
})
export class LinkButtonComponent implements OnInit {

  @Input() pageContent: PageContentModel

  title: string
  url: string
  currentLang: string

  constructor(public translateService: TranslateService) {
    this.currentLang = translateService.currentLang

    translateService.onLangChange.subscribe(lang => {
      this.setTextByLanguage(lang.lang)
    })}

  ngOnInit(): void {
    this.setTextByLanguage(this.currentLang)
  }

  setTextByLanguage(lang: string){
    if (lang == 'en'){
      this.title = this.pageContent.Title
      this.url = this.pageContent.Content
    } else {
      this.title = this.pageContent.TitleFr
      this.url = this.pageContent.ContentFr
    }
  }

  linkButtonClicked(url: string){
    openNewTab(url)
  }


}
